import { produce } from 'immer';
import {
  SET_NEED_TO_CONFIRM_ORDERS,
  SET_CURRENT_OPEN_TAB,
  SET_NEED_TO_SHIP_ORDERS,
  SET_OPEN_ORDERS,
  SET_SHIPPED_ORDERS,
} from 'store/constants/action-types';

const initialState = {
  confirm: {
    orders: [],
    metadata: {
      currentPage: 1,
      totalCount: 0,
    },
  },
  toShip: {
    orders: [],
    metadata: {
      currentPage: 1,
      totalCount: 0,
    },
  },
  shipped: {
    orders: [],
    metadata: {
      currentPage: 1,
      totalCount: 0,
    },
  },
  all: {
    orders: [],
    metadata: {
      currentPage: 1,
      totalCount: 0,
    },
  },
  currentTab: 'confirm',
};

export const openOrdersReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_NEED_TO_CONFIRM_ORDERS:
        draft.confirm.orders = action.payload.orders;
        draft.confirm.metadata = action.payload.metadata;
        break;
      case SET_NEED_TO_SHIP_ORDERS:
        draft.toShip.orders = action.payload.orders;
        draft.toShip.metadata = action.payload.metadata;
        break;
      case SET_OPEN_ORDERS:
        draft.all.orders = action.payload.orders;
        draft.all.metadata = action.payload.metadata;
        break;
      case SET_SHIPPED_ORDERS:
        draft.shipped.orders = action.payload.orders;
        draft.shipped.metadata = action.payload.metadata;
        break;
      case SET_CURRENT_OPEN_TAB:
        draft.currentTab = action.payload;
        break;
      default:
    }
  });

export default openOrdersReducer;
